export class DefaultApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns void
     * @throws ApiError
     */
    submitJob({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/jobs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns GetVersionDTO Get version
     * @throws ApiError
     */
    getVersion() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/version',
        });
    }
    /**
     * @returns SetVersionResponseDto Set version
     * @throws ApiError
     */
    setVersion({ requestBody, }) {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/version',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Save opened email event
     * @returns any
     * @throws ApiError
     */
    getEmailTrackingEvent({ data, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/email-tracking-event/opened/{data}',
            path: {
                'data': data,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    receiveFormData({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/person-ingestion/webhook',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    retryWebhook() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/person-ingestion/webhook/retry/{id}',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    ingestStagedWebhooks() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/person-ingestion/webhook/ingest-staged',
        });
    }
}
